import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ReportFiltersResponse, ReportingInfoResponse } from '../models/mxp-report.model';

@Injectable({ providedIn: 'root' })
export class MxpReportService {
  private readonly url = environment.identityUrl.replace(/\/$/, '') + '/api/mxp-reports';

  constructor(private readonly http: HttpClient) {}

  getReportFilters(): Observable<ReportFiltersResponse> {
    return this.http.get<ReportFiltersResponse>(this.url + '/filters');
  }

  getReportingInfo(): Observable<ReportingInfoResponse> {
    return this.http.get<ReportingInfoResponse>(this.url + '/reporting-info');
  }
}
